export default {
  message: {
    id: 'shopping_assistant_fab_message',
    defaultMessage: 'Ask me',
  },
  ariaLabel: {
    id: 'shopping_assistant_fab_aria_label',
    defaultMessage: 'Open Back Market AI',
  },
} as const
